import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import classNames from "classnames"

import { useLazyGetNewOrdersQuantityQuery } from "store/api/ordersApi"
import styles from "assets/scss/index.module.scss"
import logo from "assets/svg/logo-white.svg"
import { ReactComponent as IconAlerts } from "assets/svg/menu-alerts.svg"
import { ReactComponent as IconCustomers } from "assets/svg/menu-customers.svg"
import { ReactComponent as IconDashboard } from "assets/svg/menu-dashboard.svg"
import { ReactComponent as IconDevice } from "assets/svg/menu-device.svg"
import { ReactComponent as IconOrders } from "assets/svg/menu-orders.svg"

import { Hamburger } from "components/common/Hamburger"
import MenuWrapper from "components/common/MenuWrapper"
import { NavLink } from "components/common/NavLink"
import { UserMenu } from "components/common/UserMenu"

import { RightSideIconsWrapper } from "../styled"

export const SalesManagerTopbar = () => {
  const [triggerGetNewOrdersQuantity, { data }] = useLazyGetNewOrdersQuantityQuery()
  const [isSticky, setSticky] = useState(false)
  const [isOpen, setOpen] = useState(false)

  const closeMenu = () => {
    setOpen(false)
  }

  const handleScroll = () => {
    const distance = window.scrollY

    if (distance > 0 && !isSticky) {
      setSticky(true)
    } else if (distance === 0 && isSticky) {
      setSticky(false)
    }
  }

  useEffect(() => {
    const setStickyOnScroll = () => handleScroll()

    window.addEventListener("scroll", setStickyOnScroll)

    return () => {
      window.removeEventListener("scroll", setStickyOnScroll)
    }
  }, [isSticky])

  useEffect(() => {
    const fetchData = async () => {
      try {
        await triggerGetNewOrdersQuantity()
      } catch (error) {
        console.error(error)
      }
    }

    const intervalId = setInterval(fetchData, 60000)
    fetchData()
    return () => clearInterval(intervalId)
  }, [])

  return (
    <header className={classNames(styles.topbar, { [styles.sticky]: isSticky })}>
      <Link className={styles.logoWrapper} to="/">
        <img className={styles.logo} src={logo} alt="logo" />
      </Link>
      <MenuWrapper isOpen={isOpen} onClose={closeMenu}>
        <NavLink to="/dashboard" className={styles.menuItem} activeClassName={styles.active} onClick={closeMenu}>
          <IconDashboard className={styles.menuIcon} />
          Dashboard
        </NavLink>
        <NavLink to="/contractors" className={styles.menuItem} activeClassName={styles.active} onClick={closeMenu}>
          <IconCustomers className={styles.menuIcon} />
          Contractors
        </NavLink>
        <NavLink to="/orders" className={styles.menuItem} activeClassName={styles.active} onClick={closeMenu}>
          <IconOrders className={styles.menuIcon} />
          Orders
          {Boolean(data?.data?.quantity) && <span className={styles.redDot}>{data?.data?.quantity}</span>}
        </NavLink>
        <NavLink to="/devices" className={styles.menuItem} activeClassName={styles.active} onClick={closeMenu}>
          <IconDevice className={classNames(styles.menuIconStroke)} />
          Devices
        </NavLink>
        <NavLink to="/alerts" className={styles.menuItem} activeClassName={styles.active} onClick={closeMenu}>
          <IconAlerts className={styles.menuIcon} />
          Alerts
        </NavLink>
      </MenuWrapper>
      <RightSideIconsWrapper>
        <Hamburger onClick={() => setOpen(!isOpen)} isOpen={isOpen} />
        <UserMenu />
      </RightSideIconsWrapper>
    </header>
  )
}
